/* main.js
Bento Box App Initialization
*/

import $ from 'jquery';
import * as Unt from './unt-init.js';
import * as App from './app/app.js';
import { api } from './fontawesome.js';


Unt.initializeScripts();
Unt.onDomReady(() => {
  Unt.optInTooltips();
  api.dom.i2svg();
  api.dom.watch();
  $('body').show();
  App.doOnDomReady();
});
App.startBentoBox();
